import Create from '../pages/create/create'

export default Create
